import type { GridStackNode, GridStackWidget } from 'gridstack/dist/types';

import type { GridItemConfig, WidgetData, WidgetState } from '@core/dashboard-types';

export const gridDtoToGridstack = (grid: WidgetData['grid']) =>
  grid && {
    x: grid.x,
    y: grid.y,
    w: grid.cols,
    h: grid.rows,
  };

export const gridstackToGridDto = (grid: WidgetState['grid']) => ({
  x: grid.x!,
  y: grid.y!,
  cols: grid.w!,
  rows: grid.h!,
});

export const gridItemConfigToGridstack = (grid: GridItemConfig) => ({
  w: grid.cols,
  h: grid.rows,
  minW: grid.minItemCols,
  minH: grid.minItemRows,
  maxW: grid.maxItemCols,
  maxH: grid.maxItemRows,
  locked: grid.locked ?? false,
  noMove: grid.noMove ?? false,
  noResize: grid.noResize ?? false,
});

export const nodeToWidget = (node: GridStackNode): GridStackWidget => {
  const keysToPick = <const>[
    'id',
    'x',
    'y',
    'h',
    'w',
    'minH',
    'minW',
    'maxH',
    'maxW',
    'locked',
    'autoPosition',
    'noResize',
    'noMove',
  ];
  return Object.fromEntries(
    keysToPick.map(key => (key in node ? [key, node[key]] : [])).filter(entry => entry.length),
  );
};

export const isSamePosition = (node1: GridStackNode, node2: GridStackNode): boolean => {
  if (!node1 || !node2) return false;

  const positionKeys = <const>['x', 'y', 'h', 'w'];
  return positionKeys.every(key => node1[key] === node2[key]);
};
